<div class="trigger-mode-radio-group">
  <label
    class="trigger-mode-radio-option"
    *ngFor="let option of options"
    [class.disabled]="disabled"
  >
    <input
      type="radio"
      [disabled]="disabled"
      [checked]="value === option.value"
      (change)="select(option.value)"
      (blur)="select(value || option.value)"
    />
    <span>{{ option.label }}</span>
  </label>
</div>
